import {writable} from 'svelte/store';

export class LoggedIn {
    private store = writable(false)
    public readonly subscribe = this.store.subscribe

    public change(loggedInState: boolean) {
        this.store.set(loggedInState)
    }
}